import React from "react";
import RequestUser from "./RequestUser";
import RequestUserForm from "./RequestUserForm";

const RequestWrapper = () => {
  return (
    <div className="flex flex-col lg:flex-row bg-[#F5FAFF] min-h-screen">
      {/* Left Side: Testimonial */}
      <div className="w-full lg:w-1/2 flex  mt-12 items-center justify-center px-4 py-8">
        <RequestUser />
      </div>

      {/* Right Side: Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-4 py-6">
        <RequestUserForm />
      </div>
    </div>
  );
};

export default RequestWrapper;
